module.exports = __webpack_public_path__ + "img/medium-explosion.d8de8617.png";